import React, { useEffect } from 'react';
import WorkPlanList from '../WorkPlanList';
import { workplanService } from '../../../../services/workplanService';
import { handleAPIErrors } from '../../../auxilaries';
import { connect } from 'react-redux';
import { updateMAINworkPlans, updateSpinnerShow, updateSnackbar, updateSettingsList, updateIsArchiveMode } from '../actions';
import { exists } from '../../../../common/utilities/utilitiesFunctions';

/**
 * MainWorkPlanList - Container Component
 * 
 * This component is responsible for:
 * - Fetching active workplans data from the API
 * - Fetching settings data from the API
 * - Managing loading and error states
 * - Passing data down to the presentational WorkPlanList component
 * 
 * This follows the Container/Presentational component pattern.
 */
function MainWorkPlanList({
	refreshAdmin,
	updateMAINworkPlans,
	updateSpinnerShow,
	updateSnackbar,
	updateSettingsList,
	updateIsArchiveMode,
	MAINworkPlans,
	...props
}) {
	useEffect(() => {
		// Reset archive mode when navigating to main workplan list
		updateIsArchiveMode(false);

		const fetchWorkplansData = async () => {
			updateSpinnerShow(true);
			try {
				let [resWorkplans, settingsList] = await Promise.all([
					workplanService.getWorkplans(),
					workplanService.getSettings()
				]);

				// Transform workplans data
				resWorkplans.data = resWorkplans.data.map(wp => {
					const currentStatus = wp.states.find(status => status.isCurrent);

					if (exists(currentStatus)) {
						wp.currentStatus = { 
							...wp.currentStatus, 
							effectiveDate: currentStatus.effectiveDate, 
							endDate: currentStatus.endDate 
						};
					} else if (wp.status === 1) {
						wp.currentStatus = { 
							...wp.currentStatus, 
							effectiveDate: wp.startDate, 
							endDate: wp.endDate 
						};
					} else {
						wp.currentStatus = { 
							...wp.currentStatus, 
							effectiveDate: 0, 
							endDate: 0 
						};
					}

					return { 
						...wp, 
						length: wp.periodLength * (wp.periodType === "Weeks" ? 7 : 1) 
					};
				});

				// Transform settings data
				settingsList = settingsList.data.map(setting => {
					return { ...setting, value: setting.id, label: setting.name };
				});

				updateMAINworkPlans(resWorkplans.data);
				updateSettingsList(settingsList);
				updateSpinnerShow(false);
			} catch (ex) {
				let errorMessage = handleAPIErrors(ex.response);
				updateSnackbar({
					typeSnackbar: 'error',
					messageSnackbar: errorMessage,
					openSnackbar: true,
				});
				updateSpinnerShow(false);
			}
		};

		fetchWorkplansData();
	}, [updateMAINworkPlans, updateSpinnerShow, updateSnackbar, updateSettingsList, updateIsArchiveMode]);

	// Pass all data and props down to the presentational component
	return (
		<WorkPlanList
			refreshAdmin={refreshAdmin}
			isArchiveMode={false}
			workPlans={MAINworkPlans}
			updateWorkPlans={updateMAINworkPlans}
			{...props}
		/>
	);
}

const mapStateToProps = state => {
	return {
		MAINworkPlans: state.MAINworkPlans,
	};
};

const mapDispatchToProps = {
	updateSpinnerShow,
	updateMAINworkPlans,
	updateSnackbar,
	updateSettingsList,
	updateIsArchiveMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainWorkPlanList);

